export default __webpack_public_path__ + "static/img-finish-products-0dd761ffaea63ec643a36466b92cb40c.webp";